export default {
  title: {
    'zh-cn': '资源中心',
    'zh-tw': '資源中心',
    'en': 'Resource Center'
  },
  // 主页面
  deviceType: {
    'zh-cn': '设备类型',
    'zh-tw': '設備類型',
    'en': 'Device Type'
  },
  resourceList: {
    'zh-cn': '资源列表',
    'zh-tw': '資源列表',
    'en': 'Resource List'
  },
  upload: {
    'zh-cn': '上传',
    'zh-tw': '上傳',
    'en': 'Upload'
  },
  // 设备类型选项
  deviceTypeFJ: {
    'zh-cn': '蜂晶',
    'zh-tw': '蜂晶',
    'en': 'FengJing'
  },
  deviceTypeFJP1F: {
    'zh-cn': '蜂晶P1F',
    'zh-tw': '蜂晶P1F',
    'en': 'FengJing P1F'
  },
  deviceTypeFJF1S: {
    'zh-cn': '跟车模组F1S',
    'zh-tw': '跟車模組F1S',
    'en': 'Following Car Module F1S'
  },
  deviceTypeHTO2S: {
    'zh-cn': '海豚O2S',
    'zh-tw': '海豚O2S',
    'en': 'Dolphin O2S'
  },
  deviceTypeFJP1S: {
    'zh-cn': '蜂晶(变焦款)',
    'zh-tw': '蜂晶(變焦款)',
    'en': 'FengJing (Zoom)'
  },
  deviceTypeFJMDF: {
    'zh-cn': '蜂晶MDF',
    'zh-tw': '蜂晶MDF',
    'en': 'FengJing MDF'
  },
  deviceTypeCommon: {
    'zh-cn': '通用',
    'zh-tw': '通用',
    'en': 'Common'
  },
  // 资源类型选项
  packageTypeFirmware: {
    'zh-cn': '固件升级包',
    'zh-tw': '固件升級包',
    'en': 'Firmware Upgrade Package'
  },
  packageTypeApp: {
    'zh-cn': '组合包(APP+固件)',
    'zh-tw': '組合包(APP+固件)',
    'en': 'Combo Package (APP+Firmware)'
  },
  packageTypeCustom: {
    'zh-cn': '二开升级包',
    'zh-tw': '二開升級包',
    'en': 'Custom Upgrade Package'
  },
  packageTypeIniConfig: {
    'zh-cn': '配置文件',
    'zh-tw': '配置文件',
    'en': 'INI Config'
  },
  // 资源卡片
  versionNumber: {
    'zh-cn': '版本号',
    'zh-tw': '版本號',
    'en': 'Version Number'
  },
  uploadDate: {
    'zh-cn': '上传日期',
    'zh-tw': '上傳日期',
    'en': 'Upload Date'
  },
  uploader: {
    'zh-cn': '上传人',
    'zh-tw': '上傳人',
    'en': 'Uploader'
  },
  deleteConfirm: {
    'zh-cn': '是否确认删除？',
    'zh-tw': '是否確認刪除？',
    'en': 'Are you sure to delete?'
  },
  deleteSuccess: {
    'zh-cn': '删除成功',
    'zh-tw': '刪除成功',
    'en': 'Delete successful'
  },
  fileUrlNotExist: {
    'zh-cn': '文件地址不存在',
    'zh-tw': '文件地址不存在',
    'en': 'File URL does not exist'
  },
  // 添加/编辑包对话框
  addPackage: {
    'zh-cn': '添加升级包',
    'zh-tw': '添加升級包',
    'en': 'Add Upgrade Package'
  },
  editPackage: {
    'zh-cn': '编辑升级包',
    'zh-tw': '編輯升級包',
    'en': 'Edit Upgrade Package'
  },
  uploadTip: {
    'zh-cn': '点击或拖拽文件到此区域上传',
    'zh-tw': '點擊或拖拽文件到此區域上傳',
    'en': 'Click or drag file to this area to upload'
  },
  uploadTipSub: {
    'zh-cn': '支持单个文件上传，文件大小不超过 {max}MB',
    'zh-tw': '支持單個文件上傳，文件大小不超過 {max}MB',
    'en': 'Support single file upload, file size not exceeding {max}MB'
  },
  applicableDevice: {
    'zh-cn': '适用设备',
    'zh-tw': '適用設備',
    'en': 'Applicable Device'
  },
  packageType: {
    'zh-cn': '升级包类型',
    'zh-tw': '升級包類型',
    'en': 'Package Type'
  },
  packageTypeAppLabel: {
    'zh-cn': '组合包(APP+固件)',
    'zh-tw': '組合包(APP+固件)',
    'en': 'Combo Package (APP+Firmware)'
  },
  packageTypeFirmwareLabel: {
    'zh-cn': '固件升级包',
    'zh-tw': '固件升級包',
    'en': 'Firmware Upgrade Package'
  },
  packageTypeCustomLabel: {
    'zh-cn': '二开升级包',
    'zh-tw': '二開升級包',
    'en': 'Custom Upgrade Package'
  },
  packageTypeIniConfigLabel: {
    'zh-cn': '配置文件',
    'zh-tw': '配置文件',
    'en': 'INI Config'
  },
  version: {
    'zh-cn': '版本号',
    'zh-tw': '版本號',
    'en': 'Version'
  },
  appVersion: {
    'zh-cn': 'APP版本',
    'zh-tw': 'APP版本',
    'en': 'APP Version'
  },
  firmwareVersion: {
    'zh-cn': '固件版本',
    'zh-tw': '固件版本',
    'en': 'Firmware Version'
  },
  packageDescription: {
    'zh-cn': '升级包描述',
    'zh-tw': '升級包描述',
    'en': 'Package Description'
  },
  packageEnable: {
    'zh-cn': '是否可用',
    'zh-tw': '是否可用',
    'en': 'Enable Package'
  },
  packageEnableTip: {
    'zh-cn': '关闭后，该升级包将不可用于设备升级',
    'zh-tw': '關閉後，該升級包將不可用於設備升級',
    'en': 'After closing, this upgrade package will not be available for device upgrade'
  },
  // 验证消息
  pleaseUploadPackageFile: {
    'zh-cn': '请上传升级包文件',
    'zh-tw': '請上傳升級包文件',
    'en': 'Please upload upgrade package file'
  },
  pleaseSelectPackageType: {
    'zh-cn': '请选择升级包类型',
    'zh-tw': '請選擇升級包類型',
    'en': 'Please select upgrade package type'
  },
  pleaseInputVersion: {
    'zh-cn': '请输入版本号',
    'zh-tw': '請輸入版本號',
    'en': 'Please input version number'
  },
  pleaseInputFirmwareVersion: {
    'zh-cn': '请输入固件版本号',
    'zh-tw': '請輸入固件版本號',
    'en': 'Please input firmware version number'
  },
  pleaseInputPackageDescription: {
    'zh-cn': '请输入升级包描述',
    'zh-tw': '請輸入升級包描述',
    'en': 'Please input package description'
  },
  pleaseSelectEnable: {
    'zh-cn': '请选择是否可用',
    'zh-tw': '請選擇是否可用',
    'en': 'Please select enable status'
  },
  pleaseSelectShowDescribe: {
    'zh-cn': '请选择是展示描述',
    'zh-tw': '請選擇是展示描述',
    'en': 'Please select show description'
  },
  // 消息提示
  fileSizeError: {
    'zh-cn': '文件大小不能超过 {max}MB',
    'zh-tw': '文件大小不能超過 {max}MB',
    'en': 'File size cannot exceed {max}MB'
  },
  addSuccess: {
    'zh-cn': '添加成功',
    'zh-tw': '添加成功',
    'en': 'Add successful'
  },
  updateSuccess: {
    'zh-cn': '更新成功',
    'zh-tw': '更新成功',
    'en': 'Update successful'
  },
  uploadFailed: {
    'zh-cn': '上传失败',
    'zh-tw': '上傳失敗',
    'en': 'Upload failed'
  },
  iniConfigFileExtError: {
    'zh-cn': '仅支持 .ini 文件',
    'zh-tw': '僅支持 .ini 文件',
    'en': 'Only .ini files are allowed'
  }
}

